export const isValidGalleryId = (nodeId: string): boolean => /^[-_\w]*$/.test(nodeId);
